import {
  ModalFooter,
  ModalBody,
  ModalHeader,
  ModalCloseButton,
  Text,
  Link,
  Button,
} from '@chakra-ui/react'
import React from 'react'

export function How({ onContinue }: { onContinue: () => void }) {
  return (
    <>
      <ModalHeader>How Stripe will verify your identity</ModalHeader>
      <ModalCloseButton mt={2} />
      <hr />
      <ModalBody mt={2}>
        <Text>
          Stripe will use biometric technology (on images of you and your IDs),
          as well as other data sources and our service providers (such as
          document issuer or authorised record holder), to confirm your
          identity, and for fraud and security purposes. You can subsequently
          opt-out by&nbsp;
          <Link
            href="https://support.stripe.com/questions/managing-your-id-verification-information#data-deletion"
            color="lyk-green"
            target='blank'
          >
            contacting Stripe.
          </Link>
          <br />
          <br />
          Stripe will store and use these images, other data collected, and the
          results of this check and share it with your merchant, in accordance
          with{' '}
          <Link href="https://stripe.com/in/privacy" color={'lyk-green'} target='blank'>
            Stripe&apos;s Privacy Policy.
          </Link>
        </Text>
      </ModalBody>

      <ModalFooter gap={3}>
        <Button
          backgroundColor={'lyk-green'}
          color={'white'}
          _hover={{ opacity: 0.6 }}
          w={'100%'}
          onClick={onContinue}
        >
          Accept and Continue
        </Button>
      </ModalFooter>
    </>
  )
}
